var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Button } from "../../../../Components/UI/Button";
import { createColumnHelper } from '@tanstack/react-table';

import { Translate } from "../../../../../I18N/Translate";
import { propertyIcons } from "../../../../Components/UI/Icons";
import { Pill } from "../../../../Components/UI";
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { useAtomValue } from 'jotai';
import { thesauriAtom, templatesAtom, relationshipTypesAtom } from "../../../../atoms";
import { translationsKeys } from "../helpers";







const columnHelper = createColumnHelper();

const LabelCell =
(handleEditProperty) =>
({ cell }) => {
  const property = cell.row.original;
  if (property.disableRowDnD) {
    return (/*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => handleEditProperty(property),
        className: "flex items-center gap-2 text-left text-primary-700 cursor-pointer font-medium" }, void 0, /*#__PURE__*/

      _jsx(LockClosedIcon, { className: "w-4 h-4 text-primary-700" }),
      cell.getValue()
      ));

  }
  return (/*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: () => handleEditProperty(property),
      className: "text-left text-primary-700 cursor-pointer font-medium" }, void 0,

    cell.getValue()
    ));

};

const TypeCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-2" }, void 0,
propertyIcons[cell.getValue()], /*#__PURE__*/
_jsx(Translate, { context: "System", className: "capitalize" }, void 0,
translationsKeys[cell.getValue()] || cell.getValue()
)
);


const ActionsCell =
(handleEditProperty) =>
({ cell }) => /*#__PURE__*/
_jsx(Button, { size: "small", styling: "light", onClick: () => handleEditProperty(cell.row.original) }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Edit")
);


const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Property");
const TypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Type");
const ActionsHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");
const OptionsHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Options");

// eslint-disable-next-line max-statements
const OptionsCell = ({ row }) => {
  const thesauri = useAtomValue(thesauriAtom);
  const templates = useAtomValue(templatesAtom);
  const relationTypes = useAtomValue(relationshipTypesAtom);

  const property = row.original;

  const content = [...templates, ...thesauri].find((c) => c._id === property.content);
  const relationType = relationTypes.find((rt) => rt._id === property.relationType);

  const propertyFlags = [
  {
    key: 'show-in-cards',
    condition: property.showInCard,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Show in cards")
  },
  {
    key: 'no-label',
    condition: property.noLabel,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "No label")
  },
  {
    key: 'use-as-filter',
    condition: property.filter,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Use as filter")
  },
  {
    key: 'priority',
    condition: property.prioritySorting,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Priority sorting")
  },
  {
    key: 'required',
    condition: property.required,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Required")
  },
  {
    key: 'defaultfilter',
    condition: property.defaultfilter,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Default filter")
  },
  {
    key: 'generated-id',
    condition: property.generatedId,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Generated ID")
  },
  {
    key: 'full-width',
    condition: property.fullWidth,
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Full width")
  },
  {
    key: 'style-cover',
    condition: property.style === 'cover',
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Fill")
  },
  {
    key: 'style-contain',
    condition: property.style === 'contain',
    label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Fit")
  },
  {
    key: 'relation-type',
    condition: relationType === null || relationType === void 0 ? void 0 : relationType.name,
    label: /*#__PURE__*/_jsx(Translate, { context: relationType === null || relationType === void 0 ? void 0 : relationType._id }, void 0, relationType === null || relationType === void 0 ? void 0 : relationType.name)
  },
  {
    key: 'content',
    condition: content === null || content === void 0 ? void 0 : content.name,
    label: /*#__PURE__*/_jsx(Translate, { context: content === null || content === void 0 ? void 0 : content._id }, void 0, content === null || content === void 0 ? void 0 : content.name)
  }];


  const pills = propertyFlags.
  filter((flag) => flag.condition).
  map((flag) => /*#__PURE__*/
  _jsx(Pill, { color: "gray" }, flag.key,
  flag.label
  )
  );

  return /*#__PURE__*/_jsx("div", { className: "flex flex-wrap gap-2" }, void 0, pills);
};

const propertyColumns =

(handleEditProperty) => [
columnHelper.accessor('label', {
  id: 'label',
  header: LabelHeader,
  cell: LabelCell(handleEditProperty),
  enableSorting: false
}),
columnHelper.accessor('type', {
  id: 'type',
  header: TypeHeader,
  cell: TypeCell,
  meta: { headerClassName: 'w-2/12' },
  enableSorting: false
}),
{
  id: 'options',
  header: OptionsHeader,
  cell: OptionsCell
},
{
  id: 'actions',
  header: ActionsHeader,
  cell: ActionsCell(handleEditProperty),
  meta: { headerClassName: 'w-0 text-center', contentClassName: 'text-center' }
}];


export { propertyColumns };